import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/globals.css';
import './styles/landing.css';
import './styles/landing-refresh.css';
import Home from './Home';
import PricingPage from './PricingPage';
import PrivacyPage from './PrivacyPage';
import TermsPage from './TermsPage';
import AuthCallbackPage from './AuthCallbackPage';
import AuthConfirmPage from './AuthConfirmPage';
import EmailConfirmedPage from './EmailConfirmedPage';
import AuthErrorPage from './AuthErrorPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/auth/confirm" element={<AuthConfirmPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/email-confirmed" element={<EmailConfirmedPage />} />
        <Route path="/auth/error" element={<AuthErrorPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
